module.exports = __webpack_public_path__ + "medical_information.1a524a19c39e5a95fe4b95230f38360a.png";